export default __webpack_public_path__ + "assets/sounds/b37c3963d177a10ce15c0eed25026bda.mp3";